import React, { Component } from "react";
import "./App.css";  // Import CSS

const sections = [
  { title: "Henrich Finance", desc: "Tailored financial solutions and investment strategies.", logo: "/hcf.png" },
  { title: "HC Esports", desc: "Professional teams, tournaments, and gaming content.", logo: "/hce.png" },
  { title: "HC Garage", desc: "State-of-the-art automotive repair and customization.", logo: "/hcg.png" },
  { title: "HK Badminton", desc: "Learn from Basic.", logo: "/hkb.png" },
];

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { currentPage: "home" };
  }

  navigateTo = (page) => {
    this.setState({ currentPage: page });
  };

  render() {
    const { currentPage } = this.state;
    return (
      <div className="container">
        <img src="/logo.png" alt="Henrich Corporation Logo" className="logo" />

        {currentPage === "home" ? (
          <div>
            <h1>Henrich Corporation</h1>
            <p>Innovating Across Industries, Shaping the Future.</p>

            <div className="cardContainer">
              {sections.map((section, index) => (
                <div key={index} className="card">
                  <img src={section.logo} alt="Sub Unit Logo" className="sub_logo" />
                  <h2>{section.title}</h2>
                  <p>{section.desc}</p>
                </div>
              ))}
            </div>

            <button className="button" onClick={() => this.navigateTo("contact")}>Contact Us</button>
          </div>
        ) : (
          <div>
            <button className="button" onClick={() => this.navigateTo("home")}>Home</button>
            <h2>Get in Touch</h2>
            <p>Youtube: https://www.youtube.com/@radiColonAnt</p>
            <p>Instagram: @henri_corporation</p>
            <p>Website: http://henri-corporation.wssatria.com/</p>

          </div>
        )}
      </div>
    );
  }
}

export default App;
